import { render, staticRenderFns } from "./rams-sign.vue?vue&type=template&id=19888ea1"
import script from "./rams-sign.vue?vue&type=script&lang=js"
export * from "./rams-sign.vue?vue&type=script&lang=js"
import style0 from "./rams-sign.vue?vue&type=style&index=0&id=19888ea1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports